/* FNDRY — hero carousel */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function Hero(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    this.peekImg = root.querySelector('[data-hero-peek-img]');
    this.index = 0;
    this.timer = null;
    this.autoplay = root.dataset.autoplay === 'true' && this.slides.length > 1;
    this.duration = parseInt(root.dataset.autoplayDuration, 10) || 6000;
    this.paused = false;

    if (!this.slides.length) return;
    this.bind();
    this.go(0, true);
  }

  Hero.prototype.bind = function () {
    var self = this;

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.go(i); self.stop(); });
    });

    this.root.querySelectorAll('[data-hero-prev]').forEach(function (el) {
      el.addEventListener('click', function () { self.go(self.index - 1); self.stop(); });
    });
    this.root.querySelectorAll('[data-hero-next]').forEach(function (el) {
      el.addEventListener('click', function () { self.go(self.index + 1); self.stop(); });
    });

    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.go(self.index - 1); self.stop(); }
      if (e.key === 'ArrowRight') { self.go(self.index + 1); self.stop(); }
    });

    this.root.addEventListener('mouseenter', function () { self.paused = true; self.pause(); });
    this.root.addEventListener('mouseleave', function () { self.paused = false; self.play(); });
    this.root.addEventListener('focusin', function () { self.paused = true; self.pause(); });
    this.root.addEventListener('focusout', function () {
      if (!self.root.contains(document.activeElement)) { self.paused = false; self.play(); }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.pause(); else self.play();
    });

    /* P15 2026-10-23: no slide changes while the hero is scrolled out of
       sight - each one restyled and repainted full-screen images nobody could
       see. It carries on from the same slide when it comes back. */
    this.offscreen = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var on = entries[entries.length - 1].isIntersecting;
        /* P15 sitewide 2026-10-23: the slow zoom on the photo (14s) rests too;
           it restyled the page every frame while she was further down. */
        self.root.toggleAttribute('data-offscreen', !on);
        if (on && self.offscreen) { self.offscreen = false; self.play(); }
        else if (!on && !self.offscreen) { self.offscreen = true; self.pause(); }
      }).observe(this.root);
    }

    /* swipe */
    var x0 = null, y0 = null;
    this.root.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    this.root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 46 && Math.abs(dx) > Math.abs(dy)) {
        self.go(self.index + (dx < 0 ? 1 : -1));
        self.stop();
      }
      x0 = y0 = null;
    }, { passive: true });
  };

  Hero.prototype.go = function (i, initial) {
    var total = this.slides.length;
    this.index = ((i % total) + total) % total;

    this.slides.forEach(function (slide, n) {
      var active = n === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.querySelectorAll('a, button').forEach(function (el) {
        if (active) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    }, this);

    this.dots.forEach(function (dot, n) {
      dot.setAttribute('aria-selected', n === this.index ? 'true' : 'false');
    }, this);

    if (this.peekImg) {
      var next = this.slides[(this.index + 1) % total];
      var src = next && next.dataset.thumb;
      if (src) this.peekImg.setAttribute('src', src);
    }

    if (!initial || this.autoplay) this.play();
  };

  Hero.prototype.play = function () {
    if (!this.autoplay || this.paused || this.offscreen || reduced.matches) return;
    this.pause();
    var self = this;
    /* P15 sitewide 2026-10-23: the progress hairline restarts across two
       frames instead of through a forced reflow (offsetWidth), which made the
       browser lay out the whole page inside this timer at every slide change -
       a long pause for a tap landing at that moment. */
    this.root.classList.remove('is-playing');
    this.restart = window.requestAnimationFrame(function () {
      self.restart = window.requestAnimationFrame(function () {
        self.restart = 0;
        if (self.timer) self.root.classList.add('is-playing');
      });
    });
    this.timer = window.setTimeout(function () { self.go(self.index + 1); }, this.duration);
  };

  Hero.prototype.pause = function () {
    window.clearTimeout(this.timer);
    this.timer = null;
    if (this.restart) { window.cancelAnimationFrame(this.restart); this.restart = 0; }
    this.root.classList.remove('is-playing');
  };

  Hero.prototype.stop = function () {
    this.autoplay = false;
    this.pause();
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-fndry-hero]').forEach(function (el) {
      if (el.__fndryHero) return;
      el.__fndryHero = new Hero(el);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-fndry-hero]');
    if (!root || !root.__fndryHero) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var i = slides.indexOf(e.target.closest('[data-hero-slide]'));
    if (i > -1) { root.__fndryHero.go(i); root.__fndryHero.pause(); }
  });
})();